import React from 'react'
import { Button, Col, Grid, Icon, Typography } from 'gu-ui-kit'
import { Link } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useSelector } from 'react-redux'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useTranslation } from 'react-i18next'
import { SecurityPassword, Status } from 'modules/User/Security/subcomponents'
import styles from 'modules/User/Security/Security.module.scss'

const Security = () => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  const breakpoints = useBreakpoint()

  const {
    initialized = false,
    enabled = false,
    is_2fa_available = false,
  } = useSelector((state) => ({
    ...state['user/2fa'],
    ...state['user/profile'],
  }))

  return (
    <>
      <Typography
        component={'h3'}
        variant={'Subtitle-25'}
        className={'margin-bottom-16'}
      >
        {t('user::security.password.heading')}
      </Typography>
      <Typography
        variant={'Body-15'}
        className={styles['security__section-summary']}
      >
        {t('user::security.password.summary')}
      </Typography>
      <table className={styles['security__table']}>
        <tbody>
          <tr>
            <td>
              <Grid gap={12} direction={'column'}>
                <Col>{t('user::security.password.label')}</Col>
                {breakpoints.sm && (
                  <Col>
                    <SecurityPassword />
                  </Col>
                )}
              </Grid>
            </td>

            <td>{!breakpoints.sm && <SecurityPassword />}</td>

            <td>
              <Button
                color={'Label-Fifth'}
                variant={'default'}
                name={'arrow1-right'}
                component={Link}
                size={'m'}
                to={pathGen(ROUTES.USER_SECURITY_PASSWORD)}
                noLabel={breakpoints.sm}
                endIcon={
                  <Icon
                    color="white"
                    name="arrow1-right"
                    size={breakpoints.sm ? 'm' : 's'}
                  />
                }
              >
                {t('user::security.password.edit')}
              </Button>
            </td>
          </tr>
          {is_2fa_available && initialized && (
            <tr>
              <td>
                <Grid gap={12} direction={'column'}>
                  <Col> {t('user::security.2fa.heading')}</Col>
                  {breakpoints.sm && (
                    <Col>
                      <Status enabled={enabled} initialized={initialized} />
                    </Col>
                  )}
                </Grid>
              </td>

              <td>
                {!breakpoints.sm && (
                  <Status enabled={enabled} initialized={initialized} />
                )}
              </td>

              <td>
                {!enabled && (
                  <Button
                    color={'Label-Fifth'}
                    variant={'default'}
                    name={'arrow1-right'}
                    component={Link}
                    size={'m'}
                    to={pathGen(ROUTES.USER_SECURITY_2FA)}
                    noLabel={breakpoints.sm}
                    endIcon={
                      <Icon
                        color="white"
                        name="arrow1-right"
                        size={breakpoints.sm ? 'm' : 's'}
                      />
                    }
                  >
                    {t('user::security.2fa.enable_2fa')}
                  </Button>
                )}

                {enabled && (
                  <Button
                    color={'Label-Fifth'}
                    name={'arrow1-right'}
                    variant={'default'}
                    component={Link}
                    size={'m'}
                    to={pathGen(ROUTES.USER_SECURITY_2FA)}
                    endIcon={
                      <Icon
                        color="white"
                        name="arrow1-right"
                        size={breakpoints.sm ? 'm' : 's'}
                      />
                    }
                  >
                    {t('user::security.2fa.disable_2fa')}
                  </Button>
                )}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  )
}

export default Security
